import i18n from '@shared/i18n'
import { HttpStatus } from '@shared/models/enums/http'

export const httpErrorMapper = {
  [HttpStatus.BAD_REQUEST]: i18n.global.t('common.badRequestError'),
  [HttpStatus.FORBIDDEN]: i18n.global.t('common.forbiddenError'),
  [HttpStatus.NOT_FOUND]: i18n.global.t('common.errorNotFound'),
  [HttpStatus.UNSUPPORTED_MEDIA_TYPE]: i18n.global.t('common.mediaError'),
  [HttpStatus.TOO_MANY_REQUESTS]: i18n.global.t('common.tooManyRequestsError'),
  [HttpStatus.INTERNAL_SERVER_ERROR]: i18n.global.t(
    'common.internalServerError'
  ),
  [HttpStatus.HTTP_VERSION_NOT_SUPPORTED]: i18n.global.t(
    'common.internalServerError'
  ),
  [HttpStatus.NOT_IMPLEMENTED]: i18n.global.t('common.internalServerError'),
  [HttpStatus.BAD_GATEWAY]: i18n.global.t('common.badGatewayError'),
  [HttpStatus.SERVICE_UNAVAILABLE]: i18n.global.t(
    'common.unavailableServiceError'
  ),
  [HttpStatus.GATEWAY_TIMEOUT]: i18n.global.t('common.timeoutGatewayError'),
}

// 5** errors mappers
export const serverErrorTitles = {
  [HttpStatus.INTERNAL_SERVER_ERROR]: i18n.global.t(
    'errors.internalServerError.serverErrorTitle'
  ),
  [HttpStatus.NOT_IMPLEMENTED]: i18n.global.t(
    'errors.notImplemented.serverErrorTitle'
  ),
  [HttpStatus.BAD_GATEWAY]: i18n.global.t('errors.badGateway.serverErrorTitle'),
  [HttpStatus.SERVICE_UNAVAILABLE]: i18n.global.t(
    'errors.serviceUnavailable.serverErrorTitle'
  ),
  [HttpStatus.GATEWAY_TIMEOUT]: i18n.global.t(
    'errors.gatewayTimeout.serverErrorTitle'
  ),
  [HttpStatus.HTTP_VERSION_NOT_SUPPORTED]: i18n.global.t(
    'errors.httpVersionNotSupported.serverErrorTitle'
  ),
}

export const serverErrorDescriptions = {
  [HttpStatus.INTERNAL_SERVER_ERROR]: i18n.global.t(
    'errors.internalServerError.serverErrorDescription'
  ),
  [HttpStatus.NOT_IMPLEMENTED]: i18n.global.t(
    'errors.notImplemented.serverErrorDescription'
  ),
  [HttpStatus.BAD_GATEWAY]: i18n.global.t(
    'errors.badGateway.serverErrorDescription'
  ),
  [HttpStatus.SERVICE_UNAVAILABLE]: i18n.global.t(
    'errors.serviceUnavailable.serverErrorDescription'
  ),
  [HttpStatus.GATEWAY_TIMEOUT]: i18n.global.t(
    'errors.gatewayTimeout.serverErrorDescription'
  ),
  [HttpStatus.HTTP_VERSION_NOT_SUPPORTED]: i18n.global.t(
    'errors.httpVersionNotSupported.serverErrorDescription'
  ),
}

export const serverErrorUserMessages = {
  [HttpStatus.INTERNAL_SERVER_ERROR]: i18n.global.t(
    'errors.internalServerError.serverErrorUserMessage'
  ),
  [HttpStatus.NOT_IMPLEMENTED]: i18n.global.t(
    'errors.notImplemented.serverErrorUserMessage'
  ),
  [HttpStatus.BAD_GATEWAY]: i18n.global.t(
    'errors.badGateway.serverErrorUserMessage'
  ),
  [HttpStatus.SERVICE_UNAVAILABLE]: i18n.global.t(
    'errors.serviceUnavailable.serverErrorUserMessage'
  ),
  [HttpStatus.GATEWAY_TIMEOUT]: i18n.global.t(
    'errors.gatewayTimeout.serverErrorUserMessage'
  ),
  [HttpStatus.HTTP_VERSION_NOT_SUPPORTED]: i18n.global.t(
    'errors.httpVersionNotSupported.serverErrorUserMessage'
  ),
}
